<template>
	<div class="mine_order">
		<div
			:class="[
				userInfo.isLoyalty
					? 'mine_order_header_is_member'
					: 'mine_order_header_no_member'
			]"
		>
			<span
				:class="{ active: mineOrderFlag === 0 }"
				@click="$router.push('/mine/order/list')"
				>{{ $t('Mine.myOrder') }}</span
			>
			<span v-if="mineOrderFlag !== 0">/</span>
			<span
				v-if="mineOrderFlag === 1"
				:class="{ active: mineOrderFlag === 1 }"
				>{{ $t('Mine.orderDetail') }}</span
			>
			<span
				v-if="mineOrderFlag === 2"
				:class="{ active: mineOrderFlag === 1 }"
				>{{ $t('Mine.commentTitle') }}</span
			>
		</div>
		<router-view />
	</div>
</template>

<script>
import userStore from '@/store/userStore/userStore.js';
export default {
	data() {
		return {
			mineOrderFlag: 0, //标题显示变换及内容切换
			getDetailId: 0 //订单id,to detail son
		};
	},
	methods: {
		whoShow() {
			switch (this.$route.name) {
				case 'mineorderlist':
					this.mineOrderFlag = 0;
					break;
				case 'mineorderdetail':
					this.mineOrderFlag = 1;
					break;
				case 'commentdetail':
					this.mineOrderFlag = 2;
					break;
                case 'commentedDetail':
                    this.mineOrderFlag = 2;
                    break;
			}
		}
	},
	created() {
		this.whoShow();
	},
	watch: {
		'$route.path': function(newval, oldval) {
			this.whoShow();
		}
	},
	computed: {
		userInfo() {
			return userStore.getters.userInfo;
		}
	},
	destroyed() {
		console.log('我的订单destroyed');
	}
};
</script>

<style lang="scss" scoped>
@mixin mine_order_header($color, $bgc, $actColor) {
	height: 50px;
	text-align: left;
	margin-left: 100px;
	margin-right: 100px;
	line-height: 50px;
	border-bottom: 1px solid #ddd;
	color: #a9a9a9;
	font-weight: 700;
	position: relative;
	padding-left: 10px;
	&::before {
		content: '';
		height: 60%;
		width: 3px;
		background-color: $bgc;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		left: 0;
	}
	span:nth-of-type(2) {
		margin: 0 10px;
	}
	.active {
		color: $actColor;
	}
}
$color_red: #d30008;
.mine_order {
	.mine_order_header_no_member {
		@include mine_order_header(#b6daf4, #0f72ab, #0f72ab);
		cursor: pointer;
	}
	.mine_order_header_is_member {
		@include mine_order_header(#f4d3a7, #987839, #a15f07);
		cursor: pointer;
	}
}
</style>
